<base-site-layout
    [heading]="heading | translate"
    [headerIcon]="icon"
    [isDialog]="true"
    (dialogCloseClicked)="close()"
>
    <p class="text-muted small mb-3">
        {{ 'Nur die hier zugewiesenen Buchungskreise stehen bei der Pflege der Zuständigkeiten zur Auswahl.' | translate }}
    </p>

    <div class="mb-3">
        <label class="form-label fw-semibold" for="company-code-select">{{ 'Buchungskreis hinzufügen' | translate }}</label>
        <select
            id="company-code-select"
            class="form-select"
            [formControl]="pendingCompanyCodeId"
            [disabled]="companyCodesLoading() || saving() || allAssigned()"
        >
            <option value="">
                @if (allAssigned()) {
                    {{ 'Alle Buchungskreise zugewiesen' | translate }}
                } @else {
                    {{ 'Bitte auswählen' | translate }}
                }
            </option>
            @for (cc of availableCompanyCodes(); track cc.id) {
                <option [value]="cc.id">{{ cc.code }} — {{ cc.name }}</option>
            }
        </select>
    </div>

    @if (feedback(); as fb) {
        <div
            class="alert d-flex align-items-center gap-2 py-2 mb-3"
            [class.alert-danger]="fb.level === 'error'"
            [class.alert-success]="fb.level === 'success'"
            role="alert"
        >
            <em
                class="fas"
                [class.fa-circle-exclamation]="fb.level === 'error'"
                [class.fa-circle-check]="fb.level === 'success'"
            ></em>
            <span class="small">{{ fb.message }}</span>
        </div>
    }

    @if (assignedCount() === 0) {
        <div class="text-muted fst-italic small py-4 text-center border rounded">
            {{ 'Noch keine Buchungskreise zugewiesen.' | translate }}
        </div>
    } @else {
        <div class="d-flex flex-column gap-2">
            @for (cc of assignedCompanyCodes(); track cc.id) {
                <div class="d-flex align-items-center gap-2 border rounded px-3 py-2 bg-white">
                    <em class="fas fa-building text-muted"></em>
                    <span class="fw-bold">{{ cc.code }}</span>
                    <span class="text-muted">—</span>
                    <span class="flex-grow-1">{{ cc.name }}</span>
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        [title]="'Entfernen' | translate"
                        [attr.aria-label]="'Entfernen' | translate"
                        [disabled]="saving()"
                        (click)="remove(cc.id)"
                    >
                        <em class="far fa-trash-can"></em>
                    </button>
                </div>
            }
        </div>
    }

    <div class="small text-muted mt-2">
        {{ '{{count}} ausgewählt' | translate: { count: assignedCount() } }}
    </div>
</base-site-layout>
